import createTopFieldSelectorFactory from "../../../../helpers/createTopFieldSelectorFactory"

const orgSearchState = state => state.orgSearchInput

const createTopFieldSelector = createTopFieldSelectorFactory(orgSearchState)

export const getOrgs = createTopFieldSelector("orgs")

export const getIsLoadingOrgs = createTopFieldSelector("isLoadingOrgs")
